import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";
import { formatNameLinkField } from "services/utility/formatting";

export const columnInfo = [
  {
    name: "name",
    fixed: true,
    heading: i18n("columns.Name"),
    formatFunc: formatNameLinkField,
    linkField: true,
    sortable: true,
  },
  {
    // TODO: verify working once https://app.clickup.com/t/86875087d complete
    name: "sortOrder",
    heading: i18n("columns.SortOrder"),
    defaultSort: true,
    fixed: true,
    fixedRightOfAction: true,
    sortable: true,
  },
];

export const LINE_ACTIONS = ["delete"];
export const BATCH_ACTIONS = ["delete"];

export function getEmptyRecord() {
  return { name: null, sortOrder: Decimal.ZERO };
}
